export default function peopleList(newProps) {
  if (newProps.data.loading === false && newProps.data.people && newProps.data.people.list) {
    let people_list = newProps.data.people.list.slice(0)
    this.props.editData && !people_list.find(o => o.id === newProps.editData.person.id) && people_list.push(newProps.editData.person)
    this.setState({people_list: people_list})
  } else {
    this.setState({people_list: []})
  }
}



// WEBPACK FOOTER //
// ./src/components/EventLog/helpers/peopleList.js